import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import get from 'lodash/get';
import config from '../../../../config';

const DEFAULT_LOCALE = config('defaultLocale');

const withWork = Component =>
  graphql(
    gql`
  query withWork($workId: ID!, $locale: String!) {
    work(workId: $workId, locale: $locale) {
      id
      ...${Component.displayName}
    }
  }
  ${Component.fragment}
`,
    {
      skip: ({ workId }) => !workId,
      options: props => {
        const locale = get(props, 'userInfo.locale', DEFAULT_LOCALE);

        return {
          variables: {
            workId: props.workId,
            locale
          }
        };
      },
      props: ({ data: { work, loading, error }, ownProps }) => ({
        ...ownProps,
        loading,
        error,
        work
      })
    }
  )(Component);

withWork.displayName = 'withWork';

export default withWork;
